<template>
  <van-field readonly center :name="schema.name + '_' + schema.uniqid" :label="schema.label"
    :placeholder="schema.placeholder" :value="schema.value" :required="schema.required === true"
    :rules="[{ required: schema.required === true, message: '请获取' + schema.label }]">
    <template slot="button">
      <van-button size="small" type="primary" icon="location" @click="onGetCurLocation()"
        native-type="button">获取</van-button>
    </template>
  </van-field>
</template>

<script>
import { Dialog, Toast } from 'vant';
let qqMapGeolocation = null;

export default {
  name: 'location',
  props: {
    schema: {
      'type': Object,
      default: {},
      required: true
    },
    pluginIndex: {
      type: Number,
      default: 0
    }
  },
  methods: {
    //获取位置
    onGetCurLocation: function () {

      var that = this;

      Toast.loading({
        message: '获取中...',
        forbidClick: true,
        duration: 9000
      });


      // //test
      // var position = {   
      //     "module":"geolocation",
      //     "nation": "中国",
      //     "province": "广东省",
      //     "city":"深圳市",
      //     "district":"南山区",
      //     "adcode":"440305", //行政区ID，六位数字, 前两位是省，中间是市，后面两位是区，比如深圳市ID为440300
      //     "addr":"深圳大学杜鹃山(白石路北250米)",
      //     "lat":22.530001, //火星坐标(gcj02)，腾讯、Google、高德通用
      //     "lng":113.935364,
      //     "accuracy":13 //误差范围，以米为单位
      // };
      // console.log(position);
      // that.schema.value = position.addr;
      // that.schema.location = position;
      // return ;

      if (qqMapGeolocation == null) {
        qqMapGeolocation = new qq.maps.Geolocation();
      }

 

      var options = { timeout: 9000 };
      qqMapGeolocation.getLocation(function (position) {
        console.log('position', position)

        that.schema.value = position.addr;
        that.schema.location = position;
        // console.log('position',that.schema);

        // 手动清除 Toast
        Toast.clear();

      }, function (err) {
        console.log('获取定位', err);
        // 手动清除 Toast
        Toast.clear();
        // console.log('定位失败！')
        Dialog.alert({
          title: '提示',
          message: '获取定位失败，请重试',
          closeOnClickOverlay: true
        }).then(() => {
          // on close
        }).catch(() => {
          // on cancel
        });
      }, options);


    },
  }
}
</script>

<style></style>